import { formatDateTime } from "aw-date-functions";
import { Machine } from "./Machine";
import { User } from "./User";

export class Assistance {
    id: number;
    machineId: number | null;
    userId: number | null;
    installation: string;
    title: string;
    description: string;
    canteen_name: string;
    type: number;
    assistance_date: Date
    imagesFolder: string
    stateId: number


    constructor() {
        const date = new Date()
        const randomNumber = parseInt((Math.random() * 500).toFixed(0))

        this.id = 0
        this.machineId = null
        this.userId = null
        this.installation = 'Awayter'
        this.title = '';
        this.description = '';
        this.canteen_name = '';
        this.type = 0;
        this.stateId = 0;
        this.assistance_date = new Date()
        this.imagesFolder = `AW_${formatDateTime(date)}-${randomNumber}`
    }
}